import * as API from 'core/api';
import { DiscountMode, NamedDiscountType } from 'core/api';
import * as SalesStore from '../SalesStore';
import { RestaurantFacade } from 'pos/facades';
import { CustomerDisplay } from 'pos/services';
import { getAuthorizerUserIdForDiscount } from 'pos/modules/helpers/named-discount-authorization';
import { Message } from 'core/ui-next/modal';

export default async function applyNamedDiscount({ discountId, line }: { discountId: number, line: Nullable<API.TicketLineDTO> }): Promise<void> {
	const ticket = SalesStore.getTicket();

	// Puedo usar el getNamedDiscountByUser porque realmente no filtra por descuentos aplicables por el usuario
	// sino que _sólo_ indica con un flag si el usuario tiene permiso o no sobre el descuento, por lo que puedo
	// ignorar ese flag sin problema.

	const ticketDiscounts = await RestaurantFacade.getNamedDiscountsByUser(ticket.Id, API.NamedDiscountType.Ticket);
	const lineDiscounts = await RestaurantFacade.getNamedDiscountsByUser(ticket.Id, API.NamedDiscountType.Line);

	const allDiscounts = ticketDiscounts.map(x => ({ ...x, Type: API.NamedDiscountType.Ticket }))
		.concat(lineDiscounts.map(x => ({ ...x, Type: API.NamedDiscountType.Line })));

	const discountToSet = allDiscounts.find(x => x.Id === discountId);

	if (!discountToSet) {
		await Message.show(API.Res.Msg.MSG_INVALID_DISCOUNT());
		return;
	}

	if (discountToSet.Type === NamedDiscountType.Ticket) {
		const result = await getAuthorizerUserIdForDiscount({ discount: discountToSet, getProposal: SalesStore.getNamedDiscountProposal });
		if (!result.ok)
			return;

		await SalesStore.setTicketNamedDiscount(discountToSet.Id, result.value);
		await CustomerDisplay.displayDiscounts(SalesStore.getTicket());
		return;
	}

	if (!line) {
		await Message.show(API.Res.Msg.MSG_DISCOUNT_REQUIRES_A_LINE());
		return;
	}

	const result = await getAuthorizerUserIdForDiscount({ discount: discountToSet, ticketLineId: line.Id, getProposal: SalesStore.getNamedDiscountProposal });
	if (!result.ok)
		return;

	await SalesStore.setLineNamedDiscount(line, discountToSet.Id, result.value);

	const lineWithDiscount = SalesStore.getLineById(line.Id);
	if (!lineWithDiscount)
		return;

	if (lineWithDiscount.AppliedDiscountMode && lineWithDiscount.AppliedDiscountMode === DiscountMode.Cash)
		await CustomerDisplay.displayLineCashDiscount(SalesStore.getTicket(), lineWithDiscount);
	else if (lineWithDiscount.AppliedDiscountMode && lineWithDiscount.AppliedDiscountMode === DiscountMode.Rate)
		await CustomerDisplay.displayLineDiscountPercentage(SalesStore.getTicket(), lineWithDiscount);



}